import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from 'recoil';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

import './assets/css/index.css';
import CookieBanner from './components/CookieBanner';
import App from './App';
import Loading from './components/Loading';

ReactDOM.render(
  <RecoilRoot>
    <Suspense fallback={ <Loading /> }>
      <I18nextProvider i18n={i18n}>
        <HelmetProvider>
          <BrowserRouter>
            <App />
            <CookieBanner />
          </BrowserRouter>
        </HelmetProvider>
      </I18nextProvider>
    </Suspense>
  </RecoilRoot>,
  document.getElementById("root")
);